import SetupAccountModule from '@/modules/setup-account';

export default SetupAccountModule;
